import React from "react";
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';

const InfantPackageDetails = () => (
  <Container style={{ padding: 4 }}>
    <Row className="package__products package__tb-infant">
      <Col xs={12} md={6} style={{ padding: 4 }}>
        <div className="package__block package__block-red package__tb-ks1">
          <div className="package__block-padding">
            <h3>Key Stage 1</h3>
            <ul>
              <li>Year 1 Phonics</li>
              <li>Spelling</li>
              <li>Arithmetic</li>
              <li>Reading</li>
              <li>Reasoning</li>
            </ul>
          </div>
        </div>
      </Col>
      <Col xs={12} md={6} style={{ padding: 4 }}>
        <div className="package__block package__block-yellow package__tb-rmr">
          <div className="package__block-padding">
            <h3>Ready-made resources</h3>
            <ul>
              <li>End of Year 1 assessments</li>
              <li>Year 2 Arithmetic tests</li>
              <li>KS1 White Rose aligned topic test</li>
              <li>Year 2 Grammar from reading</li>
              <li>KS1 Whiteboard Guided Reading</li>
            </ul>
          </div>
        </div>
      </Col>
    </Row>
  </Container>
);

const CompletePackageDetails = () => (
  <Container style={{ padding: 4 }}>
    <Row className="package__products package__tb-complete">
      <Col xs={12} md={8}>
        <Row>
          <Col xs={12} md={6} style={{ padding: 4 }}>
            <div className="package__block package__block-red package__tb-ks1">
              <div className="package__block-padding">
                <h3>Key Stage 1</h3>
                <ul>
                  <li>Year 1 Phonics</li>
                  <li>Spelling</li>
                  <li>Arithmetic</li>
                  <li>Reading</li>
                  <li>Reasoning</li>
                </ul>
                <p>* Includes KS1 past SATs questions</p>
              </div>
            </div>
          </Col>
          <Col xs={12} md={6} style={{ padding: 4 }}>
            <div className="package__block package__block-red package__tb-ks2">
              <div className="package__block-padding">
                <h3>Key Stage 2</h3>
                <ul>
                  <li>Year 3, 4, 5 Arithmetic <span className="new-package"> (NEW Content for 2025)</span></li>
                  <li>Year 3, 4, 5 Reasoning <span className="new-package"> (NEW Content for 2025)</span></li>
                  <li>Year 3, 4, 5 Grammar and Punctuation <span className="new-package"> (NEW Content for 2025)</span></li>
                  <li>Arithmetic</li>
                  <li>Reading</li>
                  <li>Reasoning</li>
                  <li>Science</li>
                  <li>Beyond Times Tables</li>
                </ul>
                <p>* Includes KS2 past SATs questions and newly-written and adapted questions for non-SATs years</p>
              </div>
            </div>
          </Col>
          <Col xs={12} style={{ padding: 4 }}>
            <div className="package__block package__block-hor package__block-red package__tb-ks1ks2">
              <div className="package__block-padding">
                <h3>Key Stage 1 &amp; 2</h3>
                <ul>
                  <li>Primary Spelling</li>
                  <li>Primary Grammar and Punctuation</li>
                  <li>Reading by Content Domain</li>
                </ul>
              </div>
            </div>
          </Col>
          <Col xs={12} style={{ padding: 4 }}>
            <div className="package__block package__block-hor package__block-red package__tb-ks3">
              <div className="package__block-padding">
                <h3>Key Stage 3</h3>
                <span>Included FREE!</span>
              </div>
            </div>
          </Col>
        </Row>
      </Col>
      <Col xs={12} md={4} style={{ padding: 4 }}>
        <div className="package__block package__block-yellow package__tb-rmr">
          <div className="package__block-padding">
            <h3>Ready-made resources </h3>
            <ul>
              <li>End of Year 1 assessments</li>
              <li>Year 2 Arithmetic tests</li>
              <li>Year 2 Grammar from reading</li>
              <li>KS1 &amp; KS2 Whiteboard Guided Reading</li>
              <li>KS1 &amp; KS2 Primary Maths Progression Map</li>
              <li>KS1 &amp; KS2 Primary GPS Progression Map <span className="new-package"> (NEW)</span></li>
              <li>KS1 &amp; KS2 White Rose aligned topic tests</li>
              <li>KS2 Maths Starters and Plenaries</li>
              <li>KS2 Arithmetic tests</li>
              <li>KS2 Reasoning Topic tests</li>
              <li>KS2 Practical Science activities</li>
              <li>KS2 Science project</li>
            </ul>
          </div>
        </div>
      </Col>
    </Row>
  </Container>
);

const CompleteAndMerit = () => (
  <Container fluid style={{ padding: 4 }}>
    <Row className="package__products package__tb-complete__merit">
      <Col xs={12} md={8}>
        <Row direction="row">
          <Col xs={12} md={6} style={{ padding: 4 }}>
            <div className="package__block package__block-red package__tb-ks1">
              <div className="package__block-padding">
                <h3>Key Stage 1</h3>
                <ul>
                  <li>Year 1 Phonics</li>
                  <li>Spelling</li>
                  <li>Arithmetic</li>
                  <li>Reading</li>
                  <li>Reasoning</li>
                </ul>
                <p>*Includes past KS1 SATs questions</p>
              </div>
            </div>
          </Col>
          <Col xs={12} md={6} style={{ padding: 4 }}>
            <div className="package__block package__block-red package__tb-ks2">
              <div className="package__block-padding">
                <h3>Key Stage 2</h3>
                <ul>
                  <li>Year 3, 4, 5 Arithmetic <span className="new-package"> (NEW Content for 2025)</span></li>
                  <li>Year 3, 4, 5 Reasoning<span className="new-package"> (NEW Content for 2025)</span></li>
                  <li>Year 3, 4, 5 Grammar and Punctuation<span className="new-package"> (NEW Content for 2025)</span></li>
                  <li>Arithmetic</li>
                  <li>Reading</li>
                  <li>Reasoning</li>
                  <li>Science</li>
                  <li>Beyond Times Tables</li>
                </ul>
                <p>* Includes past KS2 SATs questions and newly written and adapted items for non-SATs years</p>
              </div>
            </div>
          </Col>
          <Col xs={12} style={{ padding: 4 }}>
            <div className="package__block package__block-hor package__block-red package__tb-ks1ks2">
              <div className="package__block-padding">
                <h3>Key Stage 1 &amp; 2</h3>
                <ul>
                <li>Primary Spelling</li>
                  <li>Primary Grammar and Punctuation</li>
                  <li>Reading by Content Domain</li>
                </ul>
              </div>
            </div>
          </Col>
          <Col xs={12} style={{ padding: 4 }}>
            <div className="package__block package__block-hor package__block-red package__tb-ks3">
              <div className="package__block-padding">
                <h3>Key Stage 3</h3>
                <span>Included FREE!</span>
              </div>
            </div>
          </Col>
        </Row>
      </Col>
      <Col xs={12} md={4} style={{ padding: 4 }}>
        <div className="package__block package__block-yellow package__tb-rmr">
          <div className="package__block-padding">
            <h3>Ready-made resources </h3>
            <ul>
              <li>End of Year 1 assessments</li>
              <li>Year 2 Arithmetic tests</li>
              <li>Year 2 Grammar from reading</li>
              <li>KS1 &amp; KS2 Whiteboard Guided Reading</li>
              <li>KS1 &amp; KS2 Primary Maths Progression Map</li>
              <li>KS1 &amp; KS2 Primary GPS Progression Map <span className="new-package"> (NEW)</span></li>
              <li>KS1 &amp; KS2 White Rose aligned topic tests</li>
              <li>KS2 Maths Starters and Plenaries</li>
              <li>KS2 Arithmetic tests</li>
              <li>KS2 Reasoning Topic tests</li>
              <li>KS2 Practical Science activities</li>
              <li>KS2 Science project</li>
            </ul>
          </div>
        </div>
      </Col>

      <Col xs={12} md={8} style={{ padding: 4 }}>
        <Row>
          <Col xs={12}>
            <div className="package__block package__block-purple">
              <div className="package__block-padding-title">
                <h2 className="complete-tnct" >
                  Testbase Standardised Tests (from September 2024)
                </h2>
              </div>
            </div>
          </Col>
          <Col xs={12} md={6} className="package__block-purple-left">
            <div className="package__block package__block-purple">
              <div className="package__block-padding-two">
                <h3>Years 1 & 2 - Termly</h3>
                <ul>
                  <li>Teacher’s guide</li>
                  <li>Reading paper 1 prompt and answer booklet</li>
                  <li>Reading paper 2 prompt booklet and answer booklet</li>
                  <li>Grammar and punctuation</li>
                  <li>Spelling</li>
                  <li>Arithmetic</li>
                  <li>Reasoning</li>
                </ul>
              </div>
            </div>
          </Col>
          <Col xs={12} md={6} className="package__block-purple-right">
            <div className="package__block package__block-purple">
              <div className="package__block-padding-two">
                <h3>Years 3, 4 & 5 - Termly</h3>
                <ul>
                  <li>Teacher’s guide</li>
                  <li>Reading source booklet and answer booklet</li>
                  <li>Grammar and punctuation</li>
                  <li>Spelling</li>
                  <li>Arithmetic</li>
                  <li>Reasoning A</li>
                  <li>Reasoning B (Year 5 only)</li>
                </ul>
              </div>
            </div>
          </Col>
        </Row>
        <Row>
          <Col xs={12} md={6} className="package__block-purple-left">
            <div className="package__block package__block-purple">
              <div className="package__block-padding-two">
                <h3>Year 6 - Autumn & Spring</h3>
                <ul>
                  <li>Teacher’s guide</li>
                  <li>Reading source booklet and answer booklet</li>
                  <li>Grammar and punctuation</li>
                  <li>Spelling</li>
                  <li>Arithmetic</li>
                  <li>Reasoning paper A</li>
                  <li>Reasoning paper B</li>
                </ul>
              </div>
            </div>
          </Col>
          <Col xs={12} md={6} className="package__block-purple-right">
            <div className="package__block package__block-purple">
              <div className="package__block-padding-two">
                <h3>Year 6 - Science Tests</h3>
                <ul>
                  <li>Teacher’s guide</li>
                  <li>Paper A</li>
                  <li>Paper B</li>
                </ul>
              </div>
            </div>
          </Col>
        </Row>
      </Col>
      <Col xs={12} md={4} style={{ padding: 4 }}>
        <Col xs={12} className="tnct__merit">
          <div className="package__block package__block-blue">
            <div className="package__block-padding">
              <h3>MERiT - online mark entry and reporting tool</h3>
              <p>
              From September 2024, enter Testbase Standardised Test marks to:
              </p>
              <ul className="merit__list">
                <li>obtain question-by-question analysis</li>
                <li>view strengths and weaknesses by curriculum strand</li>
                <li>benchmark performance against the population.</li>
              </ul>
            </div>
          </div>
        </Col>
      </Col>
    </Row>
  </Container>
);

export { InfantPackageDetails, CompletePackageDetails, CompleteAndMerit };
